module.exports = __webpack_public_path__ + "static/screen-web@2x-953355fc52706dfc83a7a78ac499a9bf.png";